// src/components/RecordingBanner.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecording } from '../RecordingContext';

const RecordingBanner = () => {
  const navigate = useNavigate();
  const {
    isRecording,
    originPath,
    elapsedTime,
  } = useRecording();

  if (!isRecording) return null;

  const formatElapsedTime = (secs) => {
    const m = Math.floor(secs / 60).toString().padStart(2, '0');
    const s = (secs % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#fff0f0',
      padding: '10px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
      zIndex: 1000
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: 'red',
          animation: 'pulse-dot 1s infinite'
        }} />
        <span>Recording in progress</span>
        <span style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{formatElapsedTime(elapsedTime)}</span>
      </div>
      <div>
        {originPath && (
          <button onClick={() => navigate(originPath)} style={{ marginRight: 10 }}>Return</button>
        )}
      </div>

      <style>{`
        @keyframes pulse-dot {
          0% { opacity: 1; }
          50% { opacity: 0.3; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default RecordingBanner;
